import { render, staticRenderFns } from "./ToolLibNew.vue?vue&type=template&id=479e5ea4&scoped=true"
import script from "./ToolLibNew.vue?vue&type=script&lang=js"
export * from "./ToolLibNew.vue?vue&type=script&lang=js"
import style0 from "./ToolLibNew.vue?vue&type=style&index=0&id=479e5ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479e5ea4",
  null
  
)

export default component.exports